import { create } from 'zustand';

interface AuthUser {
  id: string;
  name: string;
  email: string;
  role: string;
  tenantId?: string;
  tenantSlug?: string;
  /** ログイン時にサーバーから渡される会社名。config 未ロード時のサイドバー表示に使用 */
  companyName?: string | null;
}

interface AuthState {
  token: string | null;
  user: AuthUser | null;
  isLoggedIn: boolean;
  login: (token: string, user: AuthUser) => void;
  logout: () => void;
}

// モック環境では専用キーを使用して本番セッションと完全分離
const TOKEN_KEY = import.meta.env.VITE_USE_MOCKS === 'true' ? 'mock_mirai_token' : 'mirai_token';
const USER_KEY = import.meta.env.VITE_USE_MOCKS === 'true' ? 'mock_mirai_user' : 'mirai_user';

function safeParseUser(): AuthUser | null {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    localStorage.removeItem(USER_KEY);
    return null;
  }
}

export const useAuthStore = create<AuthState>((set) => ({
  token: localStorage.getItem(TOKEN_KEY),
  user: safeParseUser(),
  isLoggedIn: !!localStorage.getItem(TOKEN_KEY),
  login: (token, user) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    set({ token, user, isLoggedIn: true });
  },
  logout: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    set({ token: null, user: null, isLoggedIn: false });
  },
}));
